import React from 'react';
import { Segment, Dropdown, Checkbox, Popup, Icon, Button } from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment';

const FilterComponent = ({
	platformList,
	selectedPlatform,
	watsons_groups,
	selectedWatsonsGroup,
	teams,
	selectedTeam,
	dropAgentList,
	selectedAgent,
	typeList,
	product,
	livechat_agent,
	agent_role,
	handleFilterChange,
	handleFilterCheck,
	t,
	defaultCheckedTypes = true,
	onFilterChange,
	excelDownload,
	excelData,
	pid,
	start_date,
	end_date,
}) => {
	const handleChange = (e, { name, value }) => {
		if (onFilterChange) {
			onFilterChange(name, value);
		}
	};
	function exportExcel(sheets, pid, start_date, end_date) {
		let now = Date.now();
		fetch('https://log.yapaytech.com/analytic/download', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				filename:
					moment(start_date).format('DD-MM-YYYY_HH:mm') +
					'_' +
					moment(end_date).format('DD-MM-YYYY_HH:mm') +
					'_agent_status_timeline_' +
					pid +
					'_' +
					'all' +
					'_' +
					now.valueOf(),
				sheets,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let dataurl = data.url;

				var a = document.createElement('a');
				a.href = dataurl;
				a.setAttribute('download', dataurl);
				a.click();
				this.setState({ allClosedloading: false });
			});
	}

	const showWatsonsGroups =
		product && product.live && product.live.settings && product.live.settings.analyticView && product.live.settings.analyticView.watsonsgroups;

	const showTeams =
		product &&
		product.live &&
		product.live.settings &&
		product.live.settings.analyticView &&
		product.live.settings.analyticView.agentTeams &&
		((livechat_agent && livechat_agent.team_admin) || (livechat_agent && livechat_agent.type && livechat_agent.type === 'admin'));

	return (
		<Segment attached="bottom">
			<div style={{ display: 'flex' }}>
				{platformList && (
					<Dropdown
						selection
						options={platformList}
						value={selectedPlatform}
						floating
						labeled
						button
						icon="filter"
						className="icon"
						name="selectedPlatform"
						onChange={(e, data) => handleChange(e, data)}
					/>
				)}

				{showWatsonsGroups && (
					<Dropdown
						selection
						options={watsons_groups}
						value={selectedWatsonsGroup}
						floating
						labeled
						button
						icon="filter"
						className="icon"
						name="selectedWatsonsGroup"
						onChange={(e, data) => handleChange(e, data)}
					/>
				)}

				{showTeams && (
					<Dropdown
						selection
						options={teams}
						value={selectedTeam}
						floating
						labeled
						button
						icon="filter"
						className="icon"
						name="selectedTeam"
						onChange={(e, data) => handleChange(e, data)}
					/>
				)}

				{agent_role !== 'agent' && (
					<div style={{ display: 'flex' }}>
						<Dropdown
							options={dropAgentList}
							selection
							value={selectedAgent}
							icon="filter"
							floating
							labeled
							button
							className="icon"
							onChange={handleFilterChange}
						/>
					</div>
				)}
			</div>

			<div style={{ display: 'flex' }}>
				{_.map(typeList, (it, i) => (
					<div key={i}>
						<Checkbox
							style={{ margin: '10px' }}
							label={it.text}
							onChange={() => handleFilterCheck(it.value)}
							defaultChecked={defaultCheckedTypes}
						/>
						<Popup trigger={<Icon name="question circle outline" />} content={t(it.desc)} size="mini" />
					</div>
				))}
			</div>
			{excelDownload ? (
				<div style={{ marginTop: '10px', display: 'flex' }}>
					<Button
						icon
						labelPosition="left"
						color="green"
						style={{ marginLeft: 'auto' }}
						/* loading={this.state.allClosedloading} */
						onClick={() => exportExcel(excelData, pid, start_date, end_date)}
					>
						<Icon name="file excel outline" />
						{t('downloadExcel')}
					</Button>
				</div>
			) : null}
		</Segment>
	);
};

export default FilterComponent;
